export const Calendar = {
  Collections: [
    {
      CalendarText: '',
      CalendarId: 1,
      CalendarColor: 'var(--op2mise-color-primary)',
    },
  ],
  ContextMenuList: [
    { text: 'New Slot', iconCss: 'e-icons e-plus', id: 'Add' },
    { text: 'Duplicate', iconCss: 'e-icons e-copy', id: 'Duplicate' },
    { text: 'Delete', iconCss: 'e-icons e-trash', id: 'Delete' },
    { text: 'Modify', iconCss: 'e-icons e-edit', id: 'Save' },
    { text: 'Shunt', iconCss: 'e-icons e-edit', id: 'Shunt' },
    { text: 'Cut', iconCss: 'e-icons e-cut', id: 'Cut' },
    { text: 'New Recurring Slot', iconCss: 'e-icons e-repeat', id: 'AddRecurrence' },
    { text: 'Today', iconCss: 'e-icons e-timeline-today', id: 'Today' },
    {
      text: 'Delete',
      id: 'DeleteRecurrenceSlot',
      iconCss: 'e-icons e-trash',
      items: [
        { text: 'Delete Occurrence', id: 'DeleteOccurrence' },
        { text: 'Delete Series', id: 'DeleteSeries' },
      ],
    },
    {
      text: 'Modify',
      id: 'EditRecurrenceSlot',
      iconCss: 'e-icons e-edit',
      items: [
        { text: 'Modify Occurrence', id: 'EditOccurrence' },
        { text: 'Modify Series', id: 'EditSeries' },
      ],
    },
    { text: 'Repeat Slot', iconCss: 'e-icons e-copy', id: 'RepeatSingle' },
    { text: 'Repeat Block', iconCss: 'e-icons e-copy', id: 'RepeatMultiple' },
    { text: 'Comment', iconCss: 'e-icons e-edit', id: 'Comment' },
  ],
};

export const Settings = {
  MajorSlots: [
    { Name: '0.05 hour', Value: 5 },
    { Name: '0.25 hour', Value: 15 },
    { Name: '0.5 hour', Value: 30 },
    { Name: '1 hour', Value: 60 },
    { Name: '1.5 hours', Value: 90 },
    { Name: '2 hours', Value: 120 },
    { Name: '2.5 hours', Value: 150 },
    { Name: '3 hours', Value: 180 },
    { Name: '3.5 hours', Value: 210 },
    { Name: '4 hours', Value: 240 },
    { Name: '4.5 hours', Value: 270 },
    { Name: '5 hours', Value: 300 },
    { Name: '5.5 hours', Value: 330 },
    { Name: '6 hours', Value: 360 },
    { Name: '6.5 hours', Value: 390 },
    { Name: '7 hours', Value: 420 },
    { Name: '7.5 hours', Value: 450 },
    { Name: '8 hours', Value: 480 },
    { Name: '8.5 hours', Value: 510 },
    { Name: '9 hours', Value: 540 },
    { Name: '9.5 hours', Value: 570 },
    { Name: '10 hours', Value: 600 },
    { Name: '10.5 hours', Value: 630 },
    { Name: '11 hours', Value: 660 },
    { Name: '11.5 hours', Value: 690 },
    { Name: '12 hours', Value: 720 },
  ],

  MinorSlots: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],

  TimeFormats: [
    { Name: '12 hours', Value: 'hh:mm a' },
    { Name: '24 hours', Value: 'HH:mm' },
  ],

  WindowsWindowsTimezoneOptions: [
    { label: "(UTC-12:00) International Date Line West", value: "Etc/GMT+12" },
    { label: "(UTC-11:00) Coordinated Universal Time-11", value: "UTC-11" },
    { label: "(UTC-10:00) Aleutian Islands", value: "America/Adak" },
    { label: "(UTC-10:00) Hawaii", value: "Pacific/Honolulu" },
    { label: "(UTC-09:30) Marquesas Islands", value: "Pacific/Marquesas" },
    { label: "(UTC-09:00) Alaska", value: "America/Anchorage" },
    { label: "(UTC-08:00) Baja California", value: "America/Tijuana" },
    { label: "(UTC-08:00) Pacific Time (US & Canada)", value: "America/Los_Angeles" },
    { label: "(UTC-07:00) Arizona", value: "America/Phoenix" },
    { label: "(UTC-07:00) Chihuahua, La Paz, Mazatlan", value: "America/Mazatlan" },
    { label: "(UTC-07:00) Mountain Time (US & Canada)", value: "America/Denver" },
    { label: "(UTC-06:00) Central America", value: "America/Guatemala" },
    { label: "(UTC-06:00) Central Time (US & Canada)", value: "America/Chicago" },
    { label: "(UTC-06:00) Easter Island", value: "Pacific/Easter" },
    { label: "(UTC-06:00) Guadalajara, Mexico City, Monterrey", value: "America/Mexico_City" },
    { label: "(UTC-06:00) Saskatchewan", value: "America/Regina" },
    { label: "(UTC-05:00) Bogota, Lima, Quito, Rio Branco", value: "America/Bogota" },
    { label: "(UTC-05:00) Eastern Time (US & Canada)", value: "America/New_York" },
    { label: "(UTC-05:00) Haiti", value: "America/Port-au-Prince" },
    { label: "(UTC-05:00) Havana", value: "America/Havana" },
    { label: "(UTC-05:00) Indiana (East)", value: "America/Indianapolis" },
    { label: "(UTC-04:00) Asuncion", value: "America/Asuncion" },
    { label: "(UTC-04:00) Atlantic Time (Canada)", value: "America/Halifax" },
    { label: "(UTC-04:00) Caracas", value: "America/Caracas" },
    { label: "(UTC-04:00) Cuiaba", value: "America/Cuiaba" },
    { label: "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan", value: "America/La_Paz" },
    { label: "(UTC-04:00) Santiago", value: "America/Santiago" },
    { label: "(UTC-03:30) Newfoundland", value: "America/St_Johns" },
    { label: "(UTC-03:00) Brasilia", value: "America/Sao_Paulo" },
    { label: "(UTC-03:00) Buenos Aires", value: "America/Argentina/Buenos_Aires" },
    { label: "(UTC-03:00) Cayenne, Fortaleza", value: "America/Cayenne" },
    { label: "(UTC-03:00) Greenland", value: "America/Godthab" },
    { label: "(UTC-03:00) Montevideo", value: "America/Montevideo" },
    { label: "(UTC-03:00) Punta Arenas", value: "America/Punta_Arenas" },
    { label: "(UTC-03:00) Saint Pierre and Miquelon", value: "America/Miquelon" },
    { label: "(UTC-02:00) Coordinated Universal Time-02", value: "UTC-02" },
    { label: "(UTC-01:00) Azores", value: "Atlantic/Azores" },
    { label: "(UTC-01:00) Cabo Verde Is.", value: "Atlantic/Cape_Verde" },
    { label: "(UTC) Coordinated Universal Time", value: "UTC" },
    { label: "(UTC+00:00) Dublin, Edinburgh, Lisbon, London", value: "Europe/London" },
    { label: "(UTC+00:00) Monrovia, Reykjavik", value: "Africa/Monrovia" },
    { label: "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna", value: "Europe/Amsterdam" },
    { label: "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague", value: "Europe/Belgrade" },
    { label: "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris", value: "Europe/Brussels" },
    { label: "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb", value: "Europe/Sarajevo" },
    { label: "(UTC+01:00) West Central Africa", value: "Africa/Lagos" },
    { label: "(UTC+02:00) Amman", value: "Asia/Amman" },
    { label: "(UTC+02:00) Athens, Bucharest", value: "Europe/Athens" },
    { label: "(UTC+02:00) Beirut", value: "Asia/Beirut" },
    { label: "(UTC+02:00) Cairo", value: "Africa/Cairo" },
    { label: "(UTC+02:00) Damascus", value: "Asia/Damascus" },
    { label: "(UTC+02:00) Gaza, Hebron", value: "Asia/Gaza" },
    { label: "(UTC+02:00) Harare, Pretoria", value: "Africa/Johannesburg" },
    { label: "(UTC+02:00) Jerusalem", value: "Asia/Jerusalem" },
    { label: "(UTC+03:00) Baghdad", value: "Asia/Baghdad" },
    { label: "(UTC+03:00) Istanbul", value: "Europe/Istanbul" },
    { label: "(UTC+03:00) Kuwait, Riyadh", value: "Asia/Kuwait" },
    { label: "(UTC+03:00) Minsk", value: "Europe/Minsk" },
    { label: "(UTC+03:00) Nairobi", value: "Africa/Nairobi" },
    { label: "(UTC+03:30) Tehran", value: "Asia/Tehran" },
    { label: "(UTC+04:00) Abu Dhabi, Muscat", value: "Asia/Dubai" },
    { label: "(UTC+04:00) Baku", value: "Asia/Baku" },
    { label: "(UTC+04:00) Moscow, St. Petersburg", value: "Europe/Moscow" },
    { label: "(UTC+04:30) Kabul", value: "Asia/Kabul" },
    { label: "(UTC+05:00) Islamabad, Karachi", value: "Asia/Karachi" },
    { label: "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi", value: "Asia/Kolkata" },
    { label: "(UTC+05:45) Kathmandu", value: "Asia/Kathmandu" },
    { label: "(UTC+06:00) Astana", value: "Asia/Almaty" },
    { label: "(UTC+06:00) Dhaka", value: "Asia/Dhaka" },
    { label: "(UTC+06:30) Yangon (Rangoon)", value: "Asia/Yangon" },
    { label: "(UTC+07:00) Bangkok, Hanoi, Jakarta", value: "Asia/Bangkok" },
    { label: "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi", value: "Asia/Shanghai" },
    { label: "(UTC+08:00) Kuala Lumpur, Singapore", value: "Asia/Singapore" },
    { label: "(UTC+08:00) Perth", value: "Australia/Perth" },
    { label: "(UTC+08:00) Taipei", value: "Asia/Taipei" },
    { label: "(UTC+08:00) Ulaanbaatar", value: "Asia/Ulaanbaatar" },
    { label: "(UTC+08:30) Pyongyang", value: "Asia/Pyongyang" },
    { label: "(UTC+09:00) Osaka, Sapporo, Tokyo", value: "Asia/Tokyo" },
    { label: "(UTC+09:00) Seoul", value: "Asia/Seoul" },
    { label: "(UTC+09:30) Adelaide", value: "Australia/Adelaide" },
    { label: "(UTC+09:30) Darwin", value: "Australia/Darwin" },
    { label: "(UTC+10:00) Brisbane", value: "Australia/Brisbane" },
    { label: "(UTC+10:00) Canberra, Melbourne, Sydney", value: "Australia/Sydney" },
    { label: "(UTC+10:00) Guam, Port Moresby", value: "Pacific/Guam" },
    { label: "(UTC+10:00) Hobart", value: "Australia/Hobart" },
    { label: "(UTC+11:00) Solomon Is., New Caledonia", value: "Pacific/Guadalcanal" },
    { label: "(UTC+12:00) Auckland, Wellington", value: "Pacific/Auckland" },
    { label: "(UTC+12:00) Fiji", value: "Pacific/Fiji" },
    { label: "(UTC+12:00) Petropavlovsk-Kamchatsky", value: "Asia/Kamchatka" },
    { label: "(UTC+13:00) Nuku'alofa", value: "Pacific/Tongatapu" },
    { label: "(UTC+14:00) Kiritimati", value: "Pacific/Kiritimati" }
  ],

  Timezones: [
    { text: 'UTC -12:00', value: 'Etc/GMT+12' },
    { text: 'UTC -11:00', value: 'Etc/GMT+11' },
    { text: 'UTC -10:00', value: 'Etc/GMT+10' },
    { text: 'UTC -09:00', value: 'Etc/GMT+9' },
    { text: 'UTC -08:00', value: 'Etc/GMT+8' },
    { text: 'UTC -07:00', value: 'Etc/GMT+7' },
    { text: 'UTC -06:00', value: 'Etc/GMT+6' },
    { text: 'UTC -05:00', value: 'Etc/GMT+5' },
    { text: 'UTC -04:00', value: 'Etc/GMT+4' },
    { text: 'UTC -03:00', value: 'Etc/GMT+3' },
    { text: 'UTC -02:00', value: 'Etc/GMT+2' },
    { text: 'UTC -01:00', value: 'Etc/GMT+1' },
    { text: 'UTC +00:00', value: 'Etc/GMT' },
    { text: 'UTC +01:00', value: 'Etc/GMT-1' },
    { text: 'UTC +02:00', value: 'Etc/GMT-2' },
    { text: 'UTC +03:00', value: 'Etc/GMT-3' },
    { text: 'UTC +04:00', value: 'Etc/GMT-4' },
    { text: 'UTC +05:00', value: 'Etc/GMT-5' },
    { text: 'UTC +05:30', value: 'Asia/Calcutta' },
    { text: 'UTC +06:00', value: 'Etc/GMT-6' },
    { text: 'UTC +07:00', value: 'Etc/GMT-7' },
    { text: 'UTC +08:00', value: 'Etc/GMT-8' },
    { text: 'UTC +09:00', value: 'Etc/GMT-9' },
    { text: 'UTC +10:00', value: 'Etc/GMT-10' },
    { text: 'UTC +11:00', value: 'Etc/GMT-11' },
    { text: 'UTC +12:00', value: 'Etc/GMT-12' },
    { text: 'UTC +13:00', value: 'Etc/GMT-13' },
    { text: 'UTC +14:00', value: 'Etc/GMT-14' },
  ],

  Tooltips: [
    { Name: 'Off', Value: 'Off' },
    { Name: 'On', Value: 'On' },
  ],

  WeekDays: [
    { text: 'Sunday', value: 0 },
    { text: 'Monday', value: 1 },
    { text: 'Tuesday', value: 2 },
    { text: 'Wednesday', value: 3 },
    { text: 'Thursday', value: 4 },
    { text: 'Friday', value: 5 },
    { text: 'Saturday', value: 6 },
  ],

};
